var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMapMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 1.33313C5.42016 1.33313 3.3335 3.4198 3.3335 5.9998C3.3335 9.4998 8.00016 14.6665 8.00016 14.6665C8.00016 14.6665 12.6668 9.4998 12.6668 5.9998C12.6668 3.4198 10.5802 1.33313 8.00016 1.33313ZM4.66683 5.9998C4.66683 4.1598 6.16016 2.66646 8.00016 2.66646C9.84016 2.66646 11.3335 4.1598 11.3335 5.9998C11.3335 7.9198 9.4135 10.7931 8.00016 12.5865C6.6135 10.8065 4.66683 7.8998 4.66683 5.9998Z",
    fill: "#A7AABD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00016 7.66646C8.92064 7.66646 9.66683 6.92027 9.66683 5.9998C9.66683 5.07932 8.92064 4.33313 8.00016 4.33313C7.07969 4.33313 6.3335 5.07932 6.3335 5.9998C6.3335 6.92027 7.07969 7.66646 8.00016 7.66646Z",
    fill: "#A7AABD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMapMarker);
export default __webpack_public_path__ + "static/media/icon_map_marker.1f781405e8b42d8e8d8db24e5f66dba2.svg";
export { ForwardRef as ReactComponent };